export const prerabotuvacData =
    [
        {
            id: "true", ime: "Да"
        },
        {
            id: "false", ime: "Не, постбербените едуваат на самата фарма"
        }
    ]